import React, { useEffect } from 'react';

const GizlilikSozlesmesi = () => {
  useEffect(() => {
    document.title = 'Gizlilik Sözleşmesi - Yaşasın Hamileyim';
  }, []);

  return (
    <div style={{ 
      maxWidth: '900px', 
      margin: '0 auto', 
      padding: '40px 20px',
      lineHeight: '1.8',
      color: '#333'
    }}>
      <h1 style={{ 
        fontSize: '2rem', 
        fontWeight: '700', 
        marginBottom: '30px',
        color: '#667eea',
        textAlign: 'center'
      }}>
        GİZLİLİK SÖZLEŞMESİ
      </h1>

      <div style={{ marginBottom: '30px' }}>
        <p style={{ fontSize: '1.1rem', marginBottom: '20px' }}>
          Bu Gizlilik Sözleşmesi, Yaşasın Hamileyim Eğitim Platformu ("Biz", "Bizim", "Platform") 
          olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") ve ilgili mevzuat 
          hükümlerine uygun olarak, kişisel verilerinizin işlenmesi, korunması ve saklanması 
          konularında bilgilendirme amacıyla hazırlanmıştır.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          1. VERİ SORUMLUSU
        </h2>
        <p>
          <strong>Veri Sorumlusu:</strong> Gyneco Sağlık Hizmetleri Ticaret Limited Şirketi<br />
          <strong>Telefon:</strong> 0 (532) 775 76 16<br />
          <strong>E-posta:</strong> info@yasasinhamileyim.com
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          2. TOPLANAN KİŞİSEL VERİLER
        </h2>
        <p>
          Platformumuz, hizmetlerimizi sunabilmek için aşağıdaki kişisel verilerinizi toplamaktadır:
        </p>
        <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
          <li><strong>Kimlik Bilgileri:</strong> Ad, soyad, TC Kimlik Numarası</li>
          <li><strong>İletişim Bilgileri:</strong> E-posta adresi, telefon numarası, adres bilgisi</li>
          <li><strong>Ödeme Bilgileri:</strong> Kredi kartı bilgileri (işleme sırasında Iyzico altyapısı üzerinden işlenir, bizim sistemimizde saklanmaz)</li>
          <li><strong>Kullanım Bilgileri:</strong> IP adresi, tarayıcı bilgisi, cihaz bilgisi, eğitim izleme geçmişi</li>
          <li><strong>Hesap Bilgileri:</strong> Kullanıcı adı, şifre (şifrelenmiş olarak saklanır)</li>
        </ul>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          3. KİŞİSEL VERİLERİN İŞLENME AMAÇLARI
        </h2>
        <p>
          Toplanan kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
        </p>
        <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
          <li>Eğitim hizmetlerinin sunulması ve yönetilmesi</li>
          <li>Hesap oluşturma ve yönetimi</li>
          <li>Ödeme işlemlerinin gerçekleştirilmesi</li>
          <li>Müşteri hizmetleri ve destek sağlanması</li>
          <li>Yasal yükümlülüklerin yerine getirilmesi</li>
          <li>Güvenlik önlemlerinin alınması</li>
          <li>İstatistiksel analizler ve raporlama</li>
          <li>Yeni hizmet ve ürünlerin geliştirilmesi</li>
          <li>Pazarlama ve tanıtım faaliyetleri (izin verilmesi halinde)</li>
        </ul>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          4. KİŞİSEL VERİLERİN İŞLENME HUKUKİ SEBEPLERİ
        </h2>
        <p>
          Kişisel verileriniz, KVKK'nın 5. ve 6. maddelerinde belirtilen aşağıdaki hukuki sebeplere 
          dayanarak işlenmektedir:
        </p>
        <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
          <li>Açık rızanız</li>
          <li>Sözleşmenin kurulması veya ifası ile doğrudan doğruya ilgili olması</li>
          <li>Yasal yükümlülüğün yerine getirilmesi</li>
          <li>Veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi</li>
          <li>Meşru menfaatlerimiz</li>
        </ul>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          5. KİŞİSEL VERİLERİN PAYLAŞILMASI
        </h2>
        <p>
          5.1. Kişisel verileriniz, yukarıda belirtilen amaçlar doğrultusunda, aşağıdaki üçüncü 
          kişilerle paylaşılabilir:
        </p>
        <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
          <li><strong>Ödeme Hizmet Sağlayıcıları:</strong> Iyzico ve benzeri ödeme altyapı sağlayıcıları</li>
          <li><strong>Hosting ve Bulut Hizmet Sağlayıcıları:</strong> Sunucu ve veri saklama hizmeti sağlayan firmalar</li>
          <li><strong>E-posta Hizmet Sağlayıcıları:</strong> E-posta gönderimi için kullanılan servisler</li>
          <li><strong>Yasal Otoriteler:</strong> Yasal yükümlülüklerimiz gereği talep edilmesi halinde</li>
        </ul>
        <p style={{ marginTop: '15px' }}>
          5.2. Kişisel verileriniz, yukarıda belirtilen amaçlar dışında üçüncü kişilerle 
          paylaşılmaz ve satılmaz.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          6. KİŞİSEL VERİLERİN GÜVENLİĞİ
        </h2>
        <p>
          6.1. Kişisel verilerinizin güvenliği için teknik ve idari önlemler alınmaktadır.
        </p>
        <p style={{ marginTop: '10px' }}>
          6.2. Verileriniz SSL sertifikası ile şifrelenmiş bağlantılar üzerinden iletilir.
        </p>
        <p style={{ marginTop: '10px' }}>
          6.3. Şifreleriniz hash algoritmaları ile şifrelenerek saklanır.
        </p>
        <p style={{ marginTop: '10px' }}>
          6.4. Düzenli güvenlik denetimleri ve yedekleme işlemleri yapılmaktadır.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          7. KİŞİSEL VERİLERİN SAKLAMA SÜRESİ
        </h2>
        <p>
          7.1. Kişisel verileriniz, işleme amacının gerektirdiği süre boyunca saklanır.
        </p>
        <p style={{ marginTop: '10px' }}>
          7.2. Yasal saklama yükümlülükleri (örneğin, muhasebe kayıtları) nedeniyle belirli 
          veriler daha uzun süre saklanabilir.
        </p>
        <p style={{ marginTop: '10px' }}>
          7.3. İşleme amacının ortadan kalkması veya saklama süresinin dolması halinde, 
          verileriniz silinir, yok edilir veya anonim hale getirilir.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          8. KVKK KAPSAMINDAKİ HAKLARINIZ
        </h2>
        <p>
          KVKK'nın 11. maddesi uyarınca, aşağıdaki haklara sahipsiniz:
        </p>
        <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
          <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
          <li>İşlenmişse buna ilişkin bilgi talep etme</li>
          <li>İşlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
          <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
          <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme</li>
          <li>KVKK'da öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini isteme</li>
          <li>Düzeltme, silme, yok edilme işlemlerinin, aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
          <li>İşlenen verilerin münhasıran otomatik sistemler ile analiz edilmesi suretiyle aleyhinize 
          bir sonucun ortaya çıkmasına itiraz etme</li>
          <li>Kanuna aykırı işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme</li>
        </ul>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          9. HAKLARINIZI KULLANMA YÖNTEMİ
        </h2>
        <p>
          Yukarıda belirtilen haklarınızı kullanmak için, kimliğinizi tespit edici belgelerle birlikte 
          aşağıdaki yöntemlerden biriyle başvurabilirsiniz:
        </p>
        <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
          <li><strong>E-posta:</strong> info@yasasinhamileyim.com</li>
          <li><strong>Telefon:</strong> 0 (532) 775 76 16</li>
          <li><strong>Yazılı Başvuru:</strong> [Adres Bilgisi] adresine noter onaylı başvuru</li>
        </ul>
        <p style={{ marginTop: '15px' }}>
          Başvurularınız en geç 30 gün içinde değerlendirilerek sonuçlandırılır.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          10. ÇEREZLER (COOKIES)
        </h2>
        <p>
          10.1. Platformumuz, kullanıcı deneyimini iyileştirmek ve hizmet kalitesini artırmak için 
          çerezler kullanmaktadır.
        </p>
        <p style={{ marginTop: '10px' }}>
          10.2. Çerezler, web sitesini ziyaret ettiğinizde cihazınıza kaydedilen küçük metin 
          dosyalarıdır.
        </p>
        <p style={{ marginTop: '10px' }}>
          10.3. Tarayıcı ayarlarınızdan çerezleri yönetebilir veya devre dışı bırakabilirsiniz.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          11. DEĞİŞİKLİKLER
        </h2>
        <p>
          Bu Gizlilik Sözleşmesi, yasal değişiklikler veya hizmetlerimizdeki güncellemeler nedeniyle 
          değiştirilebilir. Değişiklikler, Platform üzerinde yayınlandığı tarihten itibaren geçerlidir.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <p style={{ marginTop: '30px', fontWeight: 'bold', fontSize: '1.1rem', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffc107' }}>
          <strong>ÖNEMLİ:</strong> Ürünü satın alarak ödeme işlemini tamamladığınızda, bu Gizlilik 
          Sözleşmesi'ni okuduğunuzu, anladığınızı ve kabul ettiğinizi beyan etmiş sayılırsınız. 
          Sözleşme, ödeme işleminin tamamlanması ile birlikte geçerli hale gelir.
        </p>
      </div>

      <div style={{ 
        marginTop: '40px', 
        padding: '20px', 
        backgroundColor: '#f5f7fa', 
        borderRadius: '8px',
        textAlign: 'center'
      }}>
        <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
          <strong>Son Güncelleme:</strong> {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>
      </div>
    </div>
  );
};

export default GizlilikSozlesmesi;

